module.exports = __webpack_public_path__ + "img/coastCleanUp_041022_E.5ee0b5b0.jpg";